import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
const API = window.location.origin + '/api';
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    try { await axios.post(`${API}/reset/forgot`, { email }); setSent(true); }
    catch (err) {}
    setLoading(false);
  };
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-black text-2xl" style={{ backgroundColor: '#B8860B' }}>X</div>
          <p className="font-bold text-gray-900 text-lg">BULLIONX</p>
        </div>
        {sent ? (
          <div className="text-center">
            <p className="text-gray-500 text-sm mb-6">If an account exists for {email}, you will receive a reset link shortly.</p>
            <Link to="/login" className="text-sm" style={{ color: '#B8860B' }}>Back to login</Link>
          </div>
        ) : (
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-6">Forgot password</h2>
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none mb-4" />
            <button onClick={handleSubmit} disabled={loading || !email} className="w-full py-3 rounded-lg text-white text-sm font-semibold disabled:opacity-50" style={{ backgroundColor: '#1a1a2e' }}>{loading ? 'Sending...' : 'Send reset link'}</button>
            <p className="text-center mt-4"><Link to="/login" className="text-xs text-gray-400">← Back to login</Link></p>
          </div>
        )}
      </div>
    </div>
  );
};
export default ForgotPassword;
